const conctactDescription = [
  {
    id: 1,
    Image: "/asset/avata.png",
    name: "Fanuel Stephen",
    tell: "+255 682 054 057",
    note: "Notes",
    share: "Share contact",
    add: "Add to Favorite",
    edit: "Edit",
    delete: "Delete",
  },
  {
    id: 2,
    Image: "/asset/avata.png",
    name: "Samwel Junior",
    tell: "+255 682 578 047",
    note: "Notes",
    share: "Share contact",
    add: "Add to Favorite",
    edit: "Edit",
    delete: "Delete",
  },
  {
    id: 3,
    Image: "/asset/avata.png",
    name: "Onesmo Stephen",
    tell: "+255 752 573 904",
    note: "Notes",
    share: "Share contact",
    add: "Add to Favorite",
    edit: "Edit",
    delete: "Delete",
  },
  {
    id: 4,
    Image: "/asset/avata.png",
    name: "Neema Onesmo",
    tell: "+255 753 849 362",
    note: "Notes",
    share: "Share contact",
    add: "Add to Favorite",
    edit: "Edit",
    delete: "Delete",
  },
  {
    id: 5,
    Image: "/asset/avata.png",
    name: "Fahad Joseph",
    tell: "+255 715 382 839",
    note: "Notes",
    share: "Share contact",
    add: "Add to Favorite",
    edit: "Edit",
    delete: "Delete",
  },
  {
    id: 6,
    Image: "/asset/avata.png",
    name: "Rosemery Mizengo",
    tell: "+255 752 162 453",
    note: "Notes",
    share: "Share contact",
    add: "Add to Favorite",
    edit: "Edit",
    delete: "Delete",
  },
  {
    id: 7,
    Image: "/asset/avata.png",
    name: "Michael Joseph",
    tell: "+255 682 746 182",
    note: "Notes",
    share: "Share contact",
    add: "Add to Favorite",
    edit: "Edit",
    delete: "Delete",
  },
  {
    id: 8,
    Image: "/asset/avata.png",
    name: "John Paulo",
    tell: "+255 682 738 172",
    note: "Notes",
    share: "Share contact",
    add: "Add to Favorite",
    edit: "Edit",
    delete: "Delete",
  },
  {
    id: 9,
    Image: "/asset/avata.png",
    name: "Joseph Mario",
    tell: "+255 682 000 289",
    note: "Notes",
    share: "Share contact",
    add: "Add to Favorite",
    edit: "Edit",
    delete: "Delete",
  },
  {
    id: 10,
    Image: "/asset/avata.png",
    name: "Mariam Fadhil",
    tell: "+255 682 901 000",
    note: "Notes",
    share: "Share contact",
    add: "Add to Favorite",
    edit: "Edit",
    delete: "Delete",
  },
  {
    id: 11,
    Image: "/asset/avata.png",
    name: "Athuman Joseph",
    tell: "+255 682 162 278",
    note: "Notes",
    share: "Share contact",
    add: "Add to Favorite",
    edit: "Edit",
    delete: "Delete",
  },
  {
    id: 12,
    Image: "/asset/avata.png",
    name: "Amin Zebedayo",
    tell: "+255 752 162 718",
    note: "Notes",
    share: "Share contact",
    add: "Add to Favorite",
    edit: "Edit",
    delete: "Delete",
  },
  {
    id: 13,
    Image: "/asset/avata.png",
    name: "Zakayo Martin",
    tell: "+255 682 091 283",
    note: "Notes",
    share: "Share contact",
    add: "Add to Favorite",
    edit: "Edit",
    delete: "Delete",
  },
  {
    id: 14,
    Image: "/asset/avata.png",
    name: "Adela Michael",
    tell: "+255 682 738 162",
    note: "Notes",
    share: "Share contact",
    add: "Add to Favorite",
    edit: "Edit",
    delete: "Delete",
  },
  {
    id: 15,
    Image: "/asset/avata.png",
    name: "Joseph Haule",
    tell: "+255 682 121 261",
    note: "Notes",
    share: "Share contact",
    add: "Add to Favorite",
    edit: "Edit",
    delete: "Delete",
  },
];

export { conctactDescription };

const contacts = [
  "Fanuel Stephen",
  "Samwel Junior",
  "Onesmo Gobrey",
  "Neema Chaula",
  "Fahad Joseph",
  "Rosemery Mizengo",
  "Michael Joseph",
  "John Paulo",
  "Joseph Mario",
  "Mariam Fadhil",
  "Athuman Joseph",
  "Amin Zebedayo",
  "Zakayo Martin",
  "Adela Michael",
  "Joseph Haule",
];
export { contacts };
